import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { RevolutionSliderTypes } from '../../enums';
import { SlideshowItemModel } from '../../models/RevolutionSlider';

interface IRevolutionSliderService {
  getSlideshowItems: (
    sliderId: RevolutionSliderTypes,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<SlideshowItemModel[]>>;
}

export const revolutionSliderService: IRevolutionSliderService = {
  getSlideshowItems(sliderId, axiosConfig) {
    return ajax.get<SlideshowItemModel[]>(
      `${config.benefitApiUrl}/slideshows`,
      axiosConfig,
    );
  },
};
